<div class="sign-status-container">
  @if (preloader) {
    <libero-preload-spinner></libero-preload-spinner>
  }
  @if (errored) {
    {{ 'additionalSignLandingPage.errored' | translate }}
  }
  @if (notFoundWithToken) {
    {{ 'additionalSignLandingPage.notFoundWithToken' | translate }}
  }
  @if (success) {
    {{ 'additionalSignLandingPage.success' | translate }}
  }
</div>